<template>
    <section class="container">
        <stockTopMenu :curPosition="$t('invoicesCenter.indexInvoicescenter')" windowId="invoicesCenter" module="invoice">
            <div slot="descript" class="row align-center space-between" style="margin-left: 100px"></div>
        </stockTopMenu>
        <div class="main">
            <div class="nav-container">
                <div class="unified-nav">
                    <div class="primary-section">
                        <div
                            v-for="item in sidebarList"
                            :key="item.key"
                            :class="['primary-tab', item.key === activeKey ? 'primary-active' : '']"
                            @click="sidebarSwitch(item.key)"
                        >
                            <span class="tab-name">{{ item.name }}</span>
                            <span class="badge" v-if='item.num*1'>{{ item.num }}</span>
                            <el-tooltip effect="dark" :content="item.prompt" placement="top">
                                <div class="info-icon">
                                    <svg viewBox="0 0 16 16" width="14" height="14">
                                        <path fill="currentColor" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7 6.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm1 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5z"/>
                                    </svg>
                                </div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div class="secondary-section">
                        <div
                            v-for="item in childerList"
                            :key="item.key"
                            :class="['secondary-tab', item.key === activeChilderKey ? 'secondary-active' : '']"
                            @click="childerSwitch(item.key)"
                        >
                            <span class="tab-name">{{ item.name }}</span>
                            <span class="badge" v-if='item.num*1'>{{ item.num }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-box">
                <keep-alive>
                    <component v-if="activeChilderKey" :ref="activeChilderKey" :is="activeChilderKey"></component>
                </keep-alive>
            </div>
        </div>
    </section>
</template>
<script>
import stockTopMenu from '@/components/stockTopMenu.vue'
import distribution from './input/distribution.vue'
import transferSlipEnter from './input/transferSlipEnter.vue'
import deptRetreat from './output/deptRetreat.vue'
import transferSlipOut from './output/transferSlipOut.vue'
import { erp2PeratingQueryClientShowNumber } from '@/libs/http/modules/erp.js'
export default {
    name: 'invoicesCenter',
    components: {
        stockTopMenu,
        distribution,
        transferSlipEnter,
        deptRetreat,
        transferSlipOut
    },
    data() {
        return {
            activeKey: 'input',
            activeChilderKey: 'distribution',
            num: 1,
            sidebarList: [],
            numberList:[]
        }
    },
    created() {
      document.title = this.$t('invoicesCenter.indexInvoicescenter')
      this.quantiting()
    },
    computed: {
        childerList() {
            return this.sidebarList.find((i) => i.key === this.activeKey)?.childer
        }
    },
    mounted() {},
    methods: {
        quantiting() {
            erp2PeratingQueryClientShowNumber({
            })
                .then((data) => {
                    this.numberList=data
                 this.sidebarList=[
             {
                name: this.$t('invoicesCenter.indexReceiving'),
                prompt: this.$t('invoicesCenter.indexUnwarehouseinvoicescounthint'),
                num: this.numberList.inTotalNumber,
                key: 'input',
                childer: [
                    { componentName: 'distribution', key: 'distribution', name: this.$t('invoicesCenter.indexStorereceipt'), num: this.numberList.warehouseDistributeNumber },
                    { componentName: 'transferSlipEnter', key: 'transferSlipEnter', name: this.$t('invoicesCenter.indexStoretransferin'), num: this.numberList.marketInNumber }
                ]
            },
            {
                name: this.$t('invoicesCenter.indexShipping'),
                prompt: this.$t('invoicesCenter.indexUnshippedinvoicescounthint'),
                num: this.numberList.outTotalNumber,
                key: 'output',
                childer: [
                    { componentName: 'deptRetreat', key: 'deptRetreat', name: this.$t('invoicesCenter.indexStorereturnwarehouse'), num: this.numberList.marketReturnWarehouseNumber },
                    { componentName: 'transferSlipOut', key: 'transferSlipOut', name: this.$t('invoicesCenter.indexStoretransferout'), num: this.numberList.marketOutNumber }
                ]
            }]
        
                })
                .catch((err) => {
                    this.$message({
                        type: 'error',
                        message: err,
                        duration: 2000,
                        showClose: true
                    })
                })
        },
        sidebarSwitch(key) {
            if (this.activeKey === key) {
                return
            }
            this.activeKey = key
            this.activeChilderKey = this.sidebarList.find((item) => {
                return item.key === key
            }).childer[0].key
        },
        childerSwitch(key) {
            this.activeChilderKey = key
        }
    }
}
</script>

<style lang="scss" scoped>
.main {
    display: flex;
    flex-direction: column;
    background-color: #f5f7fa;
    height: 94vh;
    box-sizing: border-box;
    
    .nav-container {
        background: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-bottom: 2px solid #e8eaed;
        
        .unified-nav {
            display: flex;
            align-items: center;
            padding: 12px 24px;
            gap: 24px;
            min-height: 60px;
            
            .primary-section {
                display: flex;
                gap: 8px;
                
                .primary-tab {
                    position: relative;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 20px;
                    font-size: 15px;
                    font-weight: 600;
                    color: #5f6368;
                    cursor: pointer;
                    border-radius: 8px;
                    transition: all 0.3s ease;
                    background: #f8f9fa;
                    border: 2px solid transparent;
                    
                    &:hover {
                        color: #202124;
                        background: #e8eaed;
                        transform: translateY(-1px);
                    }
                    
                    .tab-name {
                        user-select: none;
                    }
                    
                    .badge {
                        min-width: 20px;
                        height: 20px;
                        padding: 0 6px;
                        border-radius: 10px;
                        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%) !important;
                        color: #fff;
                        font-size: 12px;
                        font-weight: 600;
                        line-height: 20px;
                        text-align: center;
                        box-shadow: 0 2px 4px rgba(238, 90, 111, 0.3);
                    }
                    
                    .info-icon {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 18px;
                        height: 18px;
                        color: #9aa0a6;
                        transition: color 0.2s ease;
                        
                        &:hover {
                            color: #5f6368;
                        }
                    }
                    
                    &.primary-active {
                        color: #fff;
                        background: linear-gradient(135deg, #1a73e8 0%, #4285f4 100%);
                        border-color: #1a73e8;
                        box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
                        transform: translateY(-2px);
                        
                        .info-icon {
                            color: rgba(255, 255, 255, 0.9);
                        }
                        
                    }
                }
            }
            
            .divider {
                width: 2px;
                height: 32px;
                background: linear-gradient(to bottom, transparent 0%, #d1d5db 20%, #d1d5db 80%, transparent 100%);
                flex-shrink: 0;
            }
            
            .secondary-section {
                display: flex;
                gap: 8px;
                flex: 1;
                
                .secondary-tab {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    padding: 8px 18px;
                    font-size: 14px;
                    font-weight: 500;
                    color: #6b7280;
                    cursor: pointer;
                    border-radius: 6px;
                    transition: all 0.25s ease;
                    background: transparent;
                    border: 1px solid #e5e7eb;
                    
                    &:hover {
                        color: #374151;
                        background: #f9fafb;
                        border-color: #d1d5db;
                    }
                    
                    .tab-name {
                        user-select: none;
                    }
                    
                    .badge {
                        min-width: 18px;
                        height: 18px;
                        padding: 0 5px;
                        border-radius: 9px;
                        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
                        color: #fff;
                        font-size: 11px;
                        font-weight: 600;
                        line-height: 18px;
                        text-align: center;
                        box-shadow: 0 1px 3px rgba(238, 90, 111, 0.3);
                    }
                    
                    &.secondary-active {
                         color: #000;
                         background: linear-gradient(135deg, #fff200 0%, #ffc107 100%);
                         border-color: #fff200;
                         box-shadow: 0 3px 10px rgba(255, 242, 0, 0.4);
                        
                    }
                }
            }
        }
    }
    
    .content-box {
        margin: 16px;
        margin-top: 8px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        overflow: hidden;
    }
}
</style>
